import { SquareDotLoadingIndicator } from '@joor/design-system'
import { Navigate, generatePath } from 'react-router-dom'
import styled from 'styled-components/macro'

import { NEW_ORDER_REVIEW, ORDER_LIST } from 'routes/paths'

import PublicInvoiceContainer from './PublicInvoice.container'

const LoaderContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const InvoiceRedirectTestIds = {
  loader: 'Invoice-content-loader',
}

export const InvoiceRedirect = ({
  loading,
  isLoggedIn,
  hasVisibility,
  orderId,
}: {
  loading: boolean
  isLoggedIn: boolean
  hasVisibility: boolean
  orderId: string
}) => {
  if (!isLoggedIn) {
    return <PublicInvoiceContainer />
  }

  if (loading) {
    return (
      <LoaderContainer>
        <SquareDotLoadingIndicator testId={InvoiceRedirectTestIds.loader} />
      </LoaderContainer>
    )
  }

  if (hasVisibility) {
    return (
      <Navigate
        to={generatePath(NEW_ORDER_REVIEW, {
          id: orderId,
        }).concat('?tab=pay')}
      />
    )
  }
  return (
    <Navigate
      to={ORDER_LIST}
      state={{
        toastMessage: {
          type: 'error',
          title: 'Visibility Error',
          description: 'You do not have access to see the invoice',
        },
      }}
    />
  )
}
